import { resolveValuesSet } from './generic-conversion.js';
export const resolveNotEqual = (dbAtom, dependencies) => {
    const notEqual = {};
    // Set default values derived from the type
    notEqual.output_type = 'boolean';
    notEqual.type = 'not-in-set-condition';
    // Convert the db value
    notEqual.value_set = resolveValuesSet(dbAtom.cases[0], dependencies);
    return notEqual;
};
export const resolveNotEqualConversion = (dbAtom, baseConversion, dependencies) => {
    const notEqualConversion = baseConversion;
    notEqualConversion.type = 'not-in-set-conversion';
    notEqualConversion.value_set = resolveValuesSet(dbAtom.cases[0], dependencies);
    notEqualConversion.return_value = notEqualConversion.output_type === 'tuple' ? dbAtom.cases[0].value : dbAtom.cases[0].value[0];
    notEqualConversion.else_value = notEqualConversion.output_type === 'tuple' ? dbAtom.fallbackValue : dbAtom.fallbackValue[0];
    return notEqualConversion;
};
//# sourceMappingURL=not-equal.js.map